module.exports = {
    "登录": "SIGN IN",
    "注册": "SIGN UP",
    "真实姓名": "Name",
    "用户名": "UserName",
    // "手机号/昵称": "UserName",
    "手机号/昵称": "Phone/Nickname",
    "家庭地址": "Address",
    "推荐方": "Referral",
    "密码": "Password",
    "设置密码": "Password",
    "重置密码": "Reset Password",
    "重复密码": "Repeat Password",
    "学员身份": "Identity",
    "视频课程": "VIDEO COURSES",
    "国学经典": "Sinology",
    "趣味汉字": "Interesting Characters",
    "传统服饰": "Traditional Costumes",
    "传统礼仪": "Traditional Etiqutte",
    "传统民乐": "Traditional Folk Music",
    "答题成功！": "Quize completed successfully",
    "得分:": "score",
    "选择课程": "Select Course",
    "作品名称": "Project Title",
    "添加作品": "Add Your Project",
    "添加描述": "Description",
    "选择要上传的文件": "Select File to Upload",
    "描述你的作品": "Dedcrip your project",
    "单选题": "single choice",
    "多选题": "multiple choice",
    "就读学校": "School",
    "微信号或邮箱": "Wechat ID or Email",
}